module.exports = __webpack_public_path__ + "static/media/arrow-down.155a9f04.png";